import type { BuyInTier, PokerGameTile } from '../types';

/**
 * Returns a distinct by id and latest lastEntry games array
 */
export const distinct = (games: PokerGameTile[]): PokerGameTile[] =>
  Object.values(
    games.reduce((gamesById: Record<string, PokerGameTile>, game) => {
      const { id, lastEntry } = game;
      if (
        (gamesById[id] &&
          Date.parse(gamesById[id].lastEntry ?? '') < Date.parse(lastEntry ?? '')) ||
        !gamesById[id]
      ) {
        gamesById[id] = game;
      }
      return gamesById;
    }, {})
  );

export function getGameBuyInTier(buyInTiers: BuyInTier[], buyIn: number): BuyInTier | undefined {
  return buyInTiers.find((tier) => buyIn === tier.buyIn + tier.rake);
}
